import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h4>Learn Workout Techniques</h4>
      <h1 className="gradient__text">What is a HIIT workout? <br /> </h1>
      <p>Most HIIT workouts consist of a fast, higher-paced load that’s followed by a short period of rest or an exercise of lower intensity. This is then repeated in small, manageable sets. The aim is to get your heart rate up to a level that you can’t sustain for long — typically in excess of 80% maximum — whilst challenging the body and allowing you to burn more fat in less time. </p>
      <h4>Learn Workout Techniques</h4>
    </div>
  </div>
);

export default Possibility;
